<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Profile Internal User</h5>
      <br />
    </div>
    <b-row>
      <b-col md="4">
        <b-card style="min-height:350px;">
          <b-row>
            <b-col class="text-center">
              <img v-if="items.image" width="100%" :src="items.image" />
              <img
                v-else
                width="100%"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRogvAnff-IUqdUshBXrme_oxwjofjtT4x1RyjZI5aF3ntLx3XI"
              />
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <!-- <b-button variant="primary" block>Upload Picture</b-button> -->
              <router-link
                :to="{name: 'editInternalUserPassword', params: {id: items.id, redirect: 'profile'}}"
                class="btn btn-primary btn-block"
              >Change Password</router-link>
              <router-link
                :to="{name: 'editInternalUser', params: {id: items.id, redirect: 'profile'}}"
                class="btn btn-primary btn-block"
              >Update Profile</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-row align="left">
            <b-col>
              <b>NIM :</b>
              <p>{{items.nim}}</p>
            </b-col>
          </b-row>
          <br />
          <b-row align="left">
            <b-col>
              <b>Username :</b>
              <p>{{items.username}}</p>
            </b-col>
            <b-col>
              <b>Role :</b>
              <p v-if="items.role == 'px'">People Experience</p>
              <p v-else-if="items.role == 'cx'">Customer Experience</p>
              <p v-else-if="items.role == 'marketing'">Marketing</p>
              <p v-else-if="items.role == 'superadmin'">Super Admin</p>
            </b-col>
          </b-row>
          <br />
          <b-row align="left">
            <b-col>
              <b>Full Name :</b>
              <p>{{items.fullname}}</p>
            </b-col>
            <b-col>
              <b>Email :</b>
              <p>{{items.email}}</p>
            </b-col>
          </b-row>
          <b-row align="left">
            <b-col>
              <b>Phone Number :</b>
              <p>{{items.phone_number}}</p>
            </b-col>
            <b-col>
              <b>Address :</b>
              <p>{{items.address}}</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      'internalUserModule/getInternalUser',
      this.$session.get('jwt').id,
    );
  },
  created() {
    this.$store.watch(
      state => state.internalUserModule.internal_user_id,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
};
</script>

<style>
</style>
